module.exports = __webpack_public_path__ + "media/images/icon_pin_all-a83ea1dde63b23fe96c4e6a80fb64552.svg";